<div class="flex items-center gap-1 {{ className }}">
    <button
        tuiIconButton
        type="button"
        appearance="outline"
        [size]="size"
        icon="svg::minus"
        shape="rounded"
        (click)="handleClickDecreaseQuantity($event)"
        [disabled]="decreaseQuantityBtnDisabled"
    ></button>

    <span
        class="w-max flex-auto !min-w-[48px] px-1 text-base flex items-center justify-center"
        [class.font-semibold]="size === 'm'"
        [class.font-bold]="size === 'l'"
    >
        {{ value | number }}
    </span>

    <button
        tuiIconButton
        type="button"
        appearance="outline"
        [size]="size"
        icon="svg::plus"
        shape="rounded"
        (click)="handleClickIncreaseQuantity($event)"
        [disabled]="increaseQuantityBtnDisabled"
    ></button>
</div>
